import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

// Views
import Dashboard from './views/Dashboard';
import Users from './views/Users';
import Profile from './views/Profile';

import Properties from './views/Properties';
import Property from './views/Property';

import Oportunities from './views/Oportunities';
import Deals from './views/Deals';
import DealsPage from './views/DealsPage';
import Oportunity from './views/Oportunity';
import Deal from './views/Deal';
import PublicDeal from './views/PublicDeal';

import ContactsPage from './views/ContactsPage';
import ContactProfile from './views/ContactProfile';
import LeadsPage from './views/LeadsPage';
import LeadProfile from './views/LeadProfile';
import PersonsPage from './views/PersonsPage';
import PersonProfile from './views/PersonProfile';
import CompaniesPage from './views/CompaniesPage';
import CompanyProfile from './views/CompanyProfile';

import DocumentsPage from './views/DocumentsPage';

import AboutUs from './views/static/about-us/AboutUsPage.jsx'

import SignUp from './views/sign_up';
import SignIn from './views/SignIn';

// import UnderDevelopment from './views/UnderDevelopment';
import NotFound from './views/not_found';
// import Users from './views/users';

export default class Routes extends Component {
  render() {
    return (
      <Switch>
        <Redirect exact from="/" to="/dashboard"/>
        <Route component={Dashboard} exact path="/dashboard" />
        <Route component={Users} exact path="/users" />
        <Route component={SignIn} exact path="/sign_in" />
        <Route component={Profile} path="/profile/:id?" />
        <Route component={SignUp} exact path="/sign_up" />
        <Route component={NotFound} exact path="/not_found" />

        <Route component={Properties} exact path="/properties" />
        <Route component={Property} exact path="/properties/:id?" />

        <Route component={Oportunities} exact path="/oportunities" />
        <Route component={Oportunity} exact path="/oportunity/:id?" />

        <Route component={Deals} exact path="/deals-back" />
        <Route component={DealsPage} exact path="/deals" />
        <Route component={Deal} exact path="/deal/:id?" />
        <Route component={PublicDeal} exact path="/public_deal/:id?" />
        <Route component={ContactsPage} exact path="/contacts" />
        <Route component={ContactProfile} path="/contacts/:id?" />

        <Route component={LeadsPage} exact path="/leads" />
        <Route component={LeadProfile} path="/lead/:id?" />

        <Route component={PersonsPage} exact path="/persons" />
        <Route component={PersonProfile} path="/person/:id?" />

        <Route component={CompaniesPage} exact path="/companies" />
        <Route component={CompanyProfile} path="/company/:id?" />

        <Route component={DocumentsPage} exact path="/documents" />
        // statics
        <Route component={AboutUs} path="/about-us" />
      </Switch>
    );
  }
}
